import React, { createContext, useContext, useEffect } from 'react';
import { useNetgsmSoftphone } from '../hooks/useNetgsmSoftphone';

const SoftphoneContext = createContext(null);

const RINGTONE_SRC = `${process.env.PUBLIC_URL || ''}/sounds/bell.mp3`;

/** Görüşme sesi — SantralPanel remount olsa bile kalır */
function SoftphoneRemoteAudio({ remoteAudioRef, reattachRemoteAudio }) {
  useEffect(() => {
    reattachRemoteAudio();
  }, [reattachRemoteAudio]);

  return <audio ref={remoteAudioRef} autoPlay playsInline hidden aria-hidden />;
}

/** Zil sesi — DOM'da kalıcı; tarayıcı otomatik oynatma kilidi startSoftphone'da açılır */
function SoftphoneRingtoneAudio({ ringtoneAudioRef }) {
  return (
    <audio
      ref={ringtoneAudioRef}
      src={RINGTONE_SRC}
      loop
      playsInline
      preload="auto"
      hidden
      aria-hidden
    />
  );
}

export function SoftphoneProvider({ children }) {
  const value = useNetgsmSoftphone();
  return (
    <SoftphoneContext.Provider value={value}>
      <SoftphoneRemoteAudio
        remoteAudioRef={value.remoteAudioRef}
        reattachRemoteAudio={value.reattachRemoteAudio}
      />
      <SoftphoneRingtoneAudio ringtoneAudioRef={value.ringtoneAudioRef} />
      {children}
    </SoftphoneContext.Provider>
  );
}

export function useSoftphone() {
  const ctx = useContext(SoftphoneContext);
  if (!ctx) {
    throw new Error('useSoftphone must be used within SoftphoneProvider');
  }
  return ctx;
}

/** SoftphoneProvider dışında güvenli kullanım (ör. satış rolü servis kaydı sayfası) */
export function useSoftphoneOptional() {
  return useContext(SoftphoneContext);
}

export default SoftphoneContext;
